<template>
  <v-sheet class="font-weight-bold pa-2 text-center" style="line-height: 1">
    <span v-if="info.doc_type === 'Обращение'">Обращение</span>
    <span v-if="info.doc_type === 'Проведение ТО и ППР'">Заказ-наряд</span>

    № {{ info.number }}
  </v-sheet>
  <v-sheet class="pa-2 text-center" style="line-height: 1">
    {{ info.object.name }}
    <span v-if="info.location" style="opacity: 0.6;"><br>{{ info.location.name }}</span>
  </v-sheet>
  <v-divider color="deep-orange" class="my-1" />
  <v-sheet class="pa-2">
    <v-chip class="mb-3" style="width: 100%" rounded="0" :color="get_status_color(info.status.name)" density="compact">{{ info.status.name }}</v-chip>
    <VueDatePicker
        :min-date="new Date()"
        :teleport="true"
        ref="dp" locale="ru-RU"
        v-if="is_draggable() && !info.permanent"
        v-model="date"
        :format="formatDate"
        @update:model-value="handle_date"
        select-text="ВЫБРАТЬ"
        cancel-text="ЗАКРЫТЬ"
        :enable-time-picker="false"

    >
      <template #clear-icon />
    </VueDatePicker>
    <v-text-field
        rounded="0"
        v-if="is_draggable() && !info.permanent"
        :readonly="info.doc_type === 'Проведение ТО и ППР' || moment(info.date.desire) < moment(moment().format('YYYY-MM-DD[T]00:00:00'))"
        color="green"
        class="align-center mt-1"
        density="compact"
        variant="outlined"
        flat
        hide-details
        single-line
        v-model="duration"
        suffix="ч/ч."
        prefix="Трудозатраты"
        v-on:keypress="validate($event)"
    >
      <template v-slot:prepend-inner>
        <v-icon :icon="['fas', 'clock']" />
      </template>
      <template v-slot:append-inner v-if="info.doc_type !== 'Проведение ТО и ППР' && info.duration !== duration">
        <v-avatar size="20" color="green" style="cursor: pointer" v-on:click="apply_duration()">
          <v-icon :icon="['fas', 'check']" />
        </v-avatar>
      </template>
    </v-text-field>
  </v-sheet>
  <v-sheet class="pa-2">
    {{ info.description }}
  </v-sheet>
  <v-sheet v-if="info.persons.length > 0">
    <v-chip style="width: 100%" rounded="0" color="green" density="compact">СПЕЦИАЛИСТЫ</v-chip>
    <v-sheet class="pa-2" >
      <template v-for="specialist in p_full" :key="specialist">
        <v-sheet v-if="specialist.name !== false">
          <v-sheet class="d-flex justify-space-between align-center" width="100%">
            {{ initials(specialist.name) }}
          </v-sheet>
          <v-sheet width="100%" class="d-flex justify-space-between" style="font-size: 10px" v-if="!specialist.days.every(e => e === true)">
            <p class="mr-1">НЕ ДОСТУПЕН</p>
            <v-spacer />
            <v-avatar color="deep-orange" class="mr-1 font-weight-bold" size="17" v-for="s in bad_days(specialist)" :key="s">
              {{ s }}
            </v-avatar>
          </v-sheet>
        </v-sheet>
      </template>
    </v-sheet>
  </v-sheet>
  <v-sheet v-else>
    <v-chip style="width: 100%" rounded="0" color="deep-orange" density="compact">СПЕЦИАЛИСТЫ НЕ НАЗНАЧЕНЫ</v-chip>
  </v-sheet>
  <v-spacer />
  <Duplicate__WP_Dialog :element="info"/>
  <v-btn rounded="0" density="compact" class="mt-1" color="green" flat v-on:click="open_mobile()">
    ОТКРЫТЬ ДОКУМЕНТ
  </v-btn>
  <v-sheet class="pa-2 text-center" style="opacity: 0.5; font-size: 10px;">
    <p v-on:click="dev = !dev">ID: {{ info.__ID }}</p>
    <pre v-if="dev" style="line-height: 1; text-align: left">{{ info }}</pre>
  </v-sheet>
</template>

<script>
import { InfoBlock, SpecialBlock } from "@/store/wp_planner/info.store";
import moment from "moment";
import { get_status_color, initials } from "../../../libs/utils";
import { Specialists, WeekDura, WeekGenerated } from "@/store/wp_planner/specialists.store";
import { DuplicatingEvent } from "@/store/wp_planner/misc.store";
import Duplicate__WP_Dialog from "@/components/wp_planner/dialogs/duplicate.dialog.vue";
import { Info } from "@/store/global/Allerts";

export default {
  name: "Document__WP_InfoCard",
  components: { Duplicate__WP_Dialog },
  data() {
    return {
      enter_event: null,
      dev: false,
      date: null,
      duration: null
    }
  },
  watch: {
    'info.date.desire'(value) {
      this.date = value
    },
    'info.duration'(value) {
      this.duration = value
    }
  },
  mounted() {
    this.date = this.info.date.desire
    this.duration = this.info.duration
  },
  methods: {
    moment,
    get_status_color,
    open_mobile: function () {
      const url = `https://mobile.scgrdn.pro/doc/${this.info.guid}`
      window.open(url, '_blank').focus();
    },
    validate: function (evt) {
      let theEvent = evt || window.event;
      if (theEvent.type === 'paste') {
        key = event.clipboardData.getData('text/plain');
      } else {
        // Handle key press
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
      }
      var regex = /[0-9]|\./;
      if( !regex.test(key) ) {
        theEvent.returnValue = false;
        if(theEvent.preventDefault) theEvent.preventDefault();
      }
    },
    apply_duration: function () {
      let duration = parseFloat(this.duration)
      if (isNaN(duration)) {
        duration = 0
      }
      const pos = moment(this.info.date.desire).day() - 1
      if (parseFloat(this.weekus[pos].used) + duration - this.info.duration > this.week_ext_data[pos]) {
        Info().warn('ВНИМАНИЕ', `${moment(this.weekus[pos].date).format('DD.MM.YYYY')} недостаточно ресурсов для выполнения данной задачи, требуется скорректировать планы!`, '#d54a0f', 'wp__day_overflow' ,'triangle-exclamation')
      }
      this.info.duration = duration
      this.duration = duration
    },
    initials,
    is_draggable: function () {
      if (['2. Решено', '2. Закрыто'].includes(this.info.status.name)) return false
      return true
    },
    formatDate: function (date) {
      if (date) {
        let d = date.getDate()
        let m = date.getMonth() + 1
        let y = date.getFullYear()

        d = d < 10 ? '0' + d : d
        m = m < 10 ? '0' + m : m


        return `В плане на: ${d}.${m}.${y}`;
      } else {
        return 'Выберите второе число'
      }
    },
    handle_date: function (modelData) {
      this.info.date.desire = moment(modelData).format("YYYY-MM-DD[T]00:00:00")
    },
    open_specialist: function (specialist) {
      this.info = specialist
    },
    bad_days: function (specialist) {
      let bad_days = []
      let names = ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС']

      for (let [index, day] of specialist.days.entries()) {
        if (!day) {
          bad_days.push(names[index])
        }
      }

      return bad_days
    }
  },
  computed: {
    week_ext_data() {
      return WeekDura().get()
    },
    specialists: {
      get() {
        return Specialists().get()
      },
      set(value) {
        Specialists().set(value)
      }
    },
    p_full() {
      let humans = []
      for (let guid of this.info.persons) {
        if (this.specialists) {
          let spec = this.specialists[this.specialists.findIndex(el=> el.guid === guid)]
          if (spec) {
            humans.push(spec)
          } else {
            humans.push({
              name: false,
              guid: guid
            })
          }
        }
      }
      return humans
    },
    desire() {
      return this.info.date.desire
    },
    weekus() {
      return WeekGenerated().get()
    },
    special: {
      get() {
        return SpecialBlock().get()
      },
      set(value) {
        SpecialBlock().set(value)
      }
    },
    info: {
      get() {
        return InfoBlock().get()
      },
      set(value) {
        InfoBlock().set(value)
      }
    },
    duplicating_event: {
      get() {
        return DuplicatingEvent().get()
      },
      set(value) {
        DuplicatingEvent().set(value)
      }
    }
  }
}
</script>

<style scoped>

</style>
